import React from 'react';
export function Footer() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    } else if (href === '#') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-slate-900 text-slate-300 py-16 md:py-20 border-t border-slate-800" data-id="element-30">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-31">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 mb-16" data-id="element-32">
          <div className="md:col-span-2" data-id="element-33">
            <a href="#" onClick={e => scrollToSection(e, '#')} className="font-serif text-2xl font-medium tracking-tight text-white mb-4 inline-block" data-id="element-34">
              Cyberspire<span className="text-sage-300" data-id="element-35">.</span>
            </a>
            <p className="text-slate-400 max-w-sm leading-relaxed mt-4" data-id="element-36">
              Specialized SEO and content marketing agency helping e-learning
              platforms bridge the visibility gap and grow enrollments.
            </p>
          </div>

          <div data-id="element-37">
            <h4 className="text-white font-medium mb-6 uppercase tracking-wider text-sm" data-id="element-38">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-39">
              <li data-id="element-40">
                <a href="#problems" onClick={e => scrollToSection(e, '#problems')} className="hover:text-white transition-colors" data-id="element-41">
                  The Challenge
                </a>
              </li>
              <li data-id="element-42">
                <a href="#services" onClick={e => scrollToSection(e, '#services')} className="hover:text-white transition-colors" data-id="element-43">
                  Services
                </a>
              </li>
              <li data-id="element-44">
                <a href="#pricing" onClick={e => scrollToSection(e, '#pricing')} className="hover:text-white transition-colors" data-id="element-45">
                  Pricing
                </a>
              </li>
              <li data-id="element-46">
                <a href="#team" onClick={e => scrollToSection(e, '#team')} className="hover:text-white transition-colors" data-id="element-47">
                  Our Team
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-48">
            <h4 className="text-white font-medium mb-6 uppercase tracking-wider text-sm" data-id="element-49">
              Contact
            </h4>
            <ul className="space-y-4" data-id="element-50">
              <li className="text-slate-400" data-id="element-51">Limassol, Cyprus</li>
              <li data-id="element-52">
                <a href="mailto:hello@cyberspire.io" className="hover:text-white transition-colors" data-id="element-53">
                  hello@cyberspire.io
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-54">
          <p className="text-sm text-slate-500" data-id="element-55">
            © 2026 Cyberspire. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-slate-500" data-id="element-56">
            <a href="#" className="hover:text-white transition-colors" data-id="element-57">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-58">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}